import SEO from "@/components/SEO";
import { PageHero, LegalDoc } from "@/components/Bits";
import { SELLER } from "@/content/policies";

export default function SellerPolicy() {
  return (
    <div data-testid="seller-policy-page">
      <SEO
        title="Seller / Middle Man Policy"
        description="Policy for Middle Men selling on the platform — independent status, KYC, subscriptions, listing standards, compliance documents, fulfilment and customer-data handling."
        path="/seller-policy"
      />
      <PageHero
        kicker="Policies"
        title="Seller / Middle Man Policy"
        subtitle="Effective from: 11 September 2026 · Rules for every Middle Man offering services or products on the platform."
      />
      <LegalDoc doc={SELLER} />
    </div>
  );
}
